import React from "react";
import { useAuth0 } from "../react-auth0-spa";
import { Link } from "react-router-dom";

import './component-style.css'

const NavBar = () => {
  const { isAuthenticated, loginWithRedirect, logout } = useAuth0();

  return (
    <div className="nav-container">
      {isAuthenticated ? (
        <Link to="/">BetterPT Playground</Link>
      ) : <div style={{ width: 60 }} />}

      {!isAuthenticated && (
        <button onClick={() => loginWithRedirect({})}>LOG IN</button>
      )}

      {isAuthenticated && (
        <>
          {/* <Link to="/profile">PROFILE</Link> */}
          <button onClick={() => logout()}>LOG OUT</button>
        </>)}
    </div>
  );
};

export default NavBar;